import {PUBLICURL} from "../../main_config";

export default [
  {
    link: "https://www.swissmedical.com.ar/prepagaclientes/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/smmp.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/smmp_color.png`,
    },
    alt: "Swiss Medical Medicina Prepaga",
  },
  {
    link: "http://www.cymsa.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/cymsa.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/cymsa_color.png`,
    },
    alt: "Clinica y maternidad suizo argentina",
  },
  {
    link: "http://www.sanatoriodelosarcos.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/arcos.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/arcos_color.png`,
    },
    alt: "Sanatorio de Los Arcos",
  },
  {
    link: "http://www.sanatorioagote.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/agote.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/agote_color.png`,
    },
    alt: "Sanatorio Agote",
  },
  {
    link: "http://www.clinicaolivos.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/olivos.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/olivos_color.png`,
    },
    alt: "Clinica Olivos",
  },
  {
    link: "http://www.clinicazabala.com.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/zabala.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/zabala_color.png`,
    },
    alt: "Clinica Zabala",
  },
  {
    link: "https://www.sanatorioaltosdesalta.com.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/altos_salta.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/altos_salta_color.png`,
    },
    alt: "Sanatorio Altos de Salta",
  },
  {
    link: "https://www.fundacionsm.org.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/fundacion.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/fundacion_color.png`,
    },
    alt: "Fundacion Swiss Medical",
  },
  {
    link: "https://www.smgcells.com.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/cells.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/cells_color.png`,
    },
    alt: "SMG Cells",
  },
  {
    link: "https://www.smglaundry.com.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/laundry.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/laundry_color.png`,
    },
    alt: "SMG Laundry",
  },
  {
    link: "https://www.swissmedicalseguros.com",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/seguros.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/seguros_color.png`,
    },
    alt: "SMG Seguros",
  },
  {
    link: "http://www.institutovida.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/instituto_salta.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/instituto_salta_color.png`,
    },
    alt: "Instituto seguros de vida de Salta",
  },
  {
    link: "https://pediatria.sanagustin.com.ar/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/san-lucas-pediatria.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/san-lucas-pediatria-color.png`,
    },
    alt: "Clinica San Lucas",
  },
  {
    link: "https://mujer.sanagustin.com.ar/ ",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/san-lucas-mujer.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/san-lucas-mujer-color.png`,
    },
    alt: "Maternidad San Lucas",
  },
  {
    link: "https://www.bcbsu.com.uy/bcbsu/",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/bcbs.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/bcbs_color.png`,
    },
    alt: "Blue cross blue shield",
  },
  {
    link: "https://www.ecco.com.ar",
    logos: {
      logoGrey: `${PUBLICURL}/assets/images/swissgroup/ecco.png`,
      logoColor: `${PUBLICURL}/assets/images/swissgroup/ecco_color.png`,
    },
    alt: "Ecco",
  }
];